import HeadMeta from "./Meta.vue";
import HeadTitle from "./Title.vue";

export default {
    HeadTitle,
    HeadMeta,
};

